<template>
  <Navbar />
  <div class="content-wrapper">
    <div class="main-content overflow-hidden">
      <div class="container">
        <CoursesHeading />
        <div class="row">
          <div class="col-xl-3 col-lg-4 lg:d-none" data-aos="fade-up" :data-aos-delay="250">
            <CourseSidebar />
          </div>

          <div class="col-xl-9 col-lg-8" data-aos="fade-up" :data-aos-delay="200">
            <CoursesList />
          </div>
        </div>
      </div>

      <div>
        <RecentCourses :latestCourses="latestCourses" :recent="false" />
      </div>
      
    </div>
    <FooterItem />
  </div>
</template>

<script>
import AOS from "aos";
import Navbar from "@/components/Layout/Navbar.vue";
import FooterItem from "@/components/Layout/FooterItem.vue";
import CourseSidebar from "@/components/courses/CourseSidebar.vue";
import CoursesList from "@/components/courses/CoursesList.vue";
import CoursesHeading from "@/components/courses/CoursesHeading.vue";
import RecentCourses from "@/components/Homepage/RecentCourses.vue";
import Loader from "@/components/common/Loader.vue";
import store from "@/store";
import { getLatestCourses } from "@/Services/api/CoursesService";
import { useHead } from "@vueuse/head";
import { mapGetters } from "vuex";
export default {
  components: {
    Navbar,
    Loader,
    CourseSidebar,
    CoursesHeading,
    CoursesList,
    RecentCourses,
    FooterItem,
  },
  data() {
    return {
      courses: null,
      loading: false,
      selectedCategories: [],
      selectedInstractors: [],
      latestCourses: []
    };
  },
  computed: {
    ...mapGetters(["currentLanguage"]),
  },
  methods: {
    //recent courses
    async getRecentCourse() {
      try {
        const response = await getLatestCourses();
        this.latestCourses = response.data;
      } catch (error) {
        console.log(error.message)
      }
    },
    updateHeadMeta() {
      const title =
        this.currentLanguage === "ar"
          ? "الدورات التدريبية - Planning Force | ابدأ رحلتك التعليمية الآن"
          : "Courses - Planning Force | Start Your Learning Journey Now";

      const description =
        this.currentLanguage === "ar"
          ? "اكتشف مجموعة واسعة من الدورات التدريبية في مختلف المجالات لمساعدتك على تطوير مهاراتك وتحقيق أهدافك المهنية والشخصية."
          : "Explore a wide range of courses across various fields to help you develop your skills and achieve your professional and personal goals.";

      const keywords =
        this.currentLanguage === "ar"
          ? "الدورات التدريبية, التعليم الإلكتروني, تطوير المهارات, التعلم, Planning Force"
          : "courses, e-learning, skill development, learning, Planning Force";

      useHead({
        title: title,
        meta: [
          { name: "description", content: description },
          { name: "keywords", content: keywords },
          { name: "robots", content: "index, follow" },
          {
            name: "author",
            content:
              this.currentLanguage === "ar"
                ? "معهد Planning Force العالي للتدريب"
                : "Planning Force High Institute for Training",
          },
          {
            name: "language",
            content: this.currentLanguage === "ar" ? "ar" : "en",
          },

          // Open Graph meta tags
          { property: "og:title", content: title },
          { property: "og:description", content: description },
          {
            property: "og:image",
            content: "https://example.com/courses-og-image.jpg",
          }, // Replace with your courses page image URL
          { property: "og:url", content: "https://example.com/courses" }, // Replace with your courses page URL
          { property: "og:type", content: "website" },

          // Twitter Card meta tags
          { name: "twitter:card", content: "summary_large_image" },
          { name: "twitter:title", content: title },
          { name: "twitter:description", content: description },
          {
            name: "twitter:image",
            content: "https://example.com/courses-twitter-image.jpg",
          }, // Replace with your courses page image URL
        ],
      });
    },
  },
  watch: {
    currentLanguage: {
      handler(newLang, oldLang) {
        this.updateHeadMeta();
        store.dispatch("categoriesList");
        store.dispatch("instructorsList");
        this.getRecentCourse();
      },
      immediate: true, // Run the handler immediately when the component is mounted
    },
  },
  mounted() {
    this.updateHeadMeta();
    AOS.init({
      duration: 1000, // Animation duration
      once: true, // Whether animation should happen only once
    });
  },
};
</script>
